import ResponseItem from './ResponseItem';
import { ResponseListProps } from '../../types/components/responseList';
import s from './ResponseList.module.css';

function ResponseList({
    responses,
    selectedResponseId,
    pageId,
    interactive,
}: ResponseListProps) {
    const responsesFromPage = responses.filter(
        (response) => response.pageId === pageId
    );

    return (
        <div className={s['responselist']}>
            {responsesFromPage?.map((responseItem, index2) => {
                return (
                    <ResponseItem
                        key={index2}
                        response={responseItem}
                        selectedResponseId={selectedResponseId}
                        interactive={interactive}
                    />
                );
            })}
        </div>
    );
}
export default ResponseList;
